import { StatementDetails } from "components/StatementDetails/StatementDetails";
import { createFileRoute } from "@tanstack/react-router";

/** Route for a patient's eob */
export const Route = createFileRoute("/$token/$channel/statement-details")({
    component: StatementDetails,
});
